import VueRouter from "vue-router";

import RouterView from "../src/components/RouterView";

export const routes = [
    {
        path: "/home",
        name: "首页",
        component: () => import("./views/home/index.vue"),
    },
    {
        path: "https://cloudprint.kuaimai.com",
        name: "云打印",
        isLink: true
    },
    {
        path: "/printer",
        name: "打印机",
        component: RouterView,
        redirect: "/printer/MianDan",
        children: [
            {
                path: "/printer/MianDan",
                name: "面单打印机",
                component: () => import("./views/printer/MianDan/index.vue"),
            },
            {
                path: "/printer/BiaoQian",
                name: "标签打印机",
                component: () => import("./views/printer/BiaoQian/index.vue"),
            },
            {
                path: "/printer/PiaoJu",
                name: "票据打印机",
                component: () => import("./views/printer/PiaoJu/index.vue"),
            },
            {
                path: "/printer/CloudPrinter",
                name: "云打印机",
                component: () => import("./views/printer/CloudPrinter/index.vue"),
            },
            {
                path: "/printer/ZhiNeng",
                name: "智能设备",
                component: () => import("./views/printer/ZhiNeng/index.vue"),
            },
        ]
    },
    {
        path: "/software",
        name: "软件服务",
        component: () => import("./views/software/index.vue"),
    },
    {
        path: "/business",
        name: "解决方案",
        component: RouterView,
        redirect: "/business/ECommerce",
        children: [
            {
                path: "/business/ECommerce",
                name: "电商行业",
                component: () => import("./views/business/ECommerce/index.vue"),
            },
            {
                path: "/business/LargeStorage",
                name: "大型仓储行业",
                hidden: true,
                component: () => import("./views/business/LargeStorage/index.vue"),
            },
            {
                path: "/business/KDWL",
                name: "快递物流行业",
                component: () => import("./views/business/KDWL/index.vue"),
            },
            {
                path: "/business/CYWM",
                name: "餐饮外卖行业",
                component: () => import("./views/business/CYWM/index.vue"),
            },
            {
                path: "/business/XXLS",
                name: "线下零售行业",
                component: () => import("./views/business/XXLS/index.vue"),
            },
            {
                path: "/business/YDZW",
                name: "政务执法行业",
                component: () => import("./views/business/YDZW/index.vue"),
            },
            {
                path: "/business/GYZZ",
                name: "工业制造业",
                component: () => import("./views/business/GYZZ/index.vue"),
            },
            {
                path: "/business/SaaS",
                name: "SaaS类ERP行业",
                component: () => import("./views/business/SaaS/index.vue"),
            },
        ]
    },
    {
        path: "/device",
        name: "驱动下载",
        component: () => import("./views/device/index.vue"),
    },
    {
        path: "/afterSalesService",
        name: "售后服务",
        component: RouterView,
        redirect: "/afterSalesService/afterSalesRepair",
        children: [
            {
                path: "/afterSalesService/afterSalesRepair",
                name: "售后维修",
                component: () => import("./views/afterSalesService/afterSalesRepair/index.vue"),
            },
            {
                path: "/afterSalesService/videos",
                name: "操作视频",
                component: () => import("./views/afterSalesService/videos/index.vue"),
            },
            {
                path: "https://dyj-old.kuaimai.com/problem/index.html",
                name: "常见问题",
                isLink: true
            },
        ]
    },
    {
        path: "/printCenter",
        name: "详情页",
        component: RouterView,
        redirect: "/printCenter/demo",
        hidden: true,
        children: [
            {
                path: "/printCenter/demo",
                name: "DETAIL",
                component: () => import("./views/printCenter/demo/demo.vue"),
            },
            {
                path: "/printCenter/MianDan/km118",
                name: "km118",
                component: () => import("./views/printCenter/MianDan/KM-118"),
            },
            {
                path: "/printCenter/MianDan/km202",
                name: "km202",
                component: () => import("./views/printCenter/MianDan/KM-202"),
            },
            {
                path: "/printCenter/MianDan/km202m",
                name: "km202m",
                component: () => import("./views/printCenter/MianDan/KM-202M"),
            },
            {
                path: "/printCenter/MianDan/km218m",
                name: "km218m",
                component: () => import("./views/printCenter/MianDan/KM-218M"),
            },
            {
                path: "/printCenter/MianDan/G31G41",
                name: "G31G41",
                component: () => import("./views/printCenter/MianDan/G31G41"),
            },
            {
                path: "/printCenter/MianDan/km360a",
                name: "km360a",
                component: () => import("./views/printCenter/MianDan/KM-360A"),
            },
            {
                path: "/printCenter/MianDan/km360se",
                name: "km360se",
                component: () => import("./views/printCenter/MianDan/KM-360SE"),
            },
            {
                path: "/printCenter/BiaoQian/km118d",
                name: "km118d",
                component: () => import("./views/printCenter/BiaoQian/KM-118D"),
            },
            {
                path: "/printCenter/BiaoQian/se210",
                name: "se210",
                component: () => import("./views/printCenter/BiaoQian/SE210"),
            },
            {
                path: "/printCenter/BiaoQian/se211",
                name: "se211",
                component: () => import("./views/printCenter/BiaoQian/SE211"),
            },
            {
                path: "/printCenter/BiaoQian/E20",
                name: "E20",
                component: () => import("./views/printCenter/BiaoQian/E20"),
            },
            {
                path: "/printCenter/BiaoQian/E30",
                name: "E30",
                component: () => import("./views/printCenter/BiaoQian/E30"),
            },
            {
                path: "/printCenter/BiaoQian/ET311",
                name: "ET311",
                component: () => import("./views/printCenter/BiaoQian/ET311"),
            },
            {
                path: "/printCenter/BiaoQian/ET411",
                name: "ET411",
                component: () => import("./views/printCenter/BiaoQian/ET411"),
            },
            {
                path: "/printCenter/PiaoJu/DP158",
                name: "DP158",
                component: () => import("./views/printCenter/PiaoJu/DP158"),
            },
            {
                path: "/printCenter/PiaoJu/UP380C",
                name: "UP380C",
                component: () => import("./views/printCenter/PiaoJu/UP380C"),
            },
            {
                path: "/printCenter/PiaoJu/UP380BT",
                name: "UP380BT",
                component: () => import("./views/printCenter/PiaoJu/UP380BT"),
            },
            {
                path: "/printCenter/ZhiNeng/D30",
                name: "D30",
                component: () => import("./views/printCenter/ZhiNeng/D30"),
            },
            {
                path: "/printCenter/ZhiNeng/D30SE",
                name: "D30SE",
                component: () => import("./views/printCenter/ZhiNeng/D30SE"),
            },
        ]
    },
    /*{
        path: "/about",
        name: "关于我们",
        component: about,
        hidden: true
    },*/
];

const router = new VueRouter({
    routes: [
        {
            path: "/",
            redirect: "/home",
        },
        ...routes,
    ],
});

export default router;
